export class AuthConfig
{
  public enablePasswordChange: boolean = false;
}
